import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import {Observable, of, throwError } from 'rxjs';


const hostnameUrls: any = {
  "dev": "https://app.dev.studentclearinghouse.org",
  "qa": "https://app.qa.studentclearinghouse.org",
  "demo": "https://app.demo.studentclearinghouse.org",
  "prod": "https://app.studentclearinghouse.org"
}

@Injectable({
  providedIn: 'root'
})
export class CloverService {

  private readonly sandboxConfig = {
    data: { cloverSdkUrl: "https://checkout.sandbox.dev.clover.com/sdk.js" }
  };

  private readonly prodConfig = {
    data: { cloverSdkUrl: "https://checkout.clover.com/sdk.js" }
  };

  getCloverByEnv(env: string) {
    return env === "prod" ? this.prodConfig : this.sandboxConfig;
  }

  constructor(private httpClient: HttpClient, @Inject(DOCUMENT) private document: any,) { }

  private hostname: string = "";
  private offline = false;

  public setOfflineMode() {
    this.offline = true;
  }

  public getCloverSDKUrlAndPublicKey() {
    return of(this.getCloverPublicKey());
  }

  getCloverPublicKey() {
    const origin = this.document.location.origin;
    const isProd = !(
      origin.includes('.dev.') ||
      origin.includes('.qa.') ||
      origin.includes('.demo.') ||
      origin.includes('staging') ||
      origin.includes('localhost')
    );
    return this.getCloverByEnv(isProd ? 'prod' : 'other');
  }

  public getMethodData(path: string) {
    console.log("Inside getMethodData ");
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      }),
    };
    return this.httpClient.get(path, httpOptions);
  }

  public postMethodData(path: string, data: any) {
    console.log("Inside postMethodData : payload ");

    let url = this.hostname + path;
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }),
    };
    return this.httpClient.post(url, data, httpOptions);
  }

  nscPost(apiUrl: any, params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpClient.post(apiUrl, params, this.getOptions())
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    })
  }

  getOptions(): any {
    var httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          "Accept": "*/*",
          "Cache-Control": "no-cache"
        }
      )
    };

    return httpOptions;
  }

  public putMethodData(path: string, data: any) {
    console.log("Inside putMethodData ");
    let url = this.hostname + path;
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }),
    };
    return this.httpClient.put(url, data, httpOptions);
  }

  public patchMethodData(path: string, data: any) {
    console.log("Inside patchMethodData ");
    let url = this.hostname + path;
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }),
    };
    return this.httpClient.patch(url, data, httpOptions);
  }

  public deleteMethodData(path: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json'
        //'Content-Type': 'application/json;charset=UTF-8'
      }),
    };
    let url = this.hostname + path;
    return this.httpClient.delete(url, httpOptions);

  }


  public getEnv(): void {
    const currentUrl = this.document.location.origin;
    if (currentUrl.includes('.dev.')) {
      this.setEnvHost("dev");
    } else if (currentUrl.includes('localhost')) {
      this.setEnvHost("dev");
    } else if (currentUrl.includes('.qa.')) {
      this.setEnvHost("qa");
    } else if (currentUrl.includes('.demo.')) {
      this.setEnvHost("demo");
    } else {
      this.setEnvHost("prod");
    }
  }

  public setEnvHost(env: string) {
    if (!env || !hostnameUrls[env]) {
      throw new Error("Illegal environment: " + env);
    } else {
      this.hostname = hostnameUrls[env];
    }
  }
}
